import { useDispatch, useSelector } from 'react-redux';
import { salesPageSelectors } from '@/Pages/Sales/services';
import { emailSendModalSelectors } from '@/ModalWindows/EmailSendModal/services/selectors';
import { useEffect, useMemo } from 'react';
import { emailSendModalActions } from '@/ModalWindows/EmailSendModal/services/reducer';
import { orderUtils } from '@/Utils/models/Order';
import { NumberGenerationType } from '@/Enums';

export const useSelectTemplateOptions = () => {
  const dispatch = useDispatch();

  const selectedSale = useSelector(salesPageSelectors.selectedSale);
  const documentType = useSelector(emailSendModalSelectors.documentType);

  useEffect(() => {
    const documentNumbers = orderUtils.getDocumentNumbersByType(documentType, selectedSale);

    dispatch(emailSendModalActions.setSelectedTypeNumbers(documentNumbers));
  }, [documentType, selectedSale]);

  const isCreatingDisabled = useMemo(() => {
    if (documentType != NumberGenerationType.CancelInvoice) {
      return false;
    }

    const noCancelInvoices = orderUtils.getCancelInvoiceNumbers(selectedSale).length == 0;
    const cancelInvoiceDisabled = orderUtils.isCreatingCancelInvoiceDisabled(selectedSale);

    return noCancelInvoices && cancelInvoiceDisabled;
  }, [selectedSale, documentType]);

  return {
    isCreatingDisabled,
  };
};
